import { get } from '../tools/http';

import uncover_img from '../tools/uncover_img';

const opp_img = uncover_img('opportunities');

const contest_from_server = {
    id: 1,
    picture_link: 'slide1.png',
    date_start: 20191212,
    date_end: 20200312,
    name: '«Абилимпикс»',
    text:
        'Международное некоммерческое движение, в рамках которого ежегодно' +
        ' проводятся чемпионаты профмастерства среди людей с инвалидностью.',
    hashes: ['участвуй', 'цифровойпрорыв', 'дляпрограммистов'],
    link: 'http://цифровойпрорыв.рф',
};

const contests_from_server = [
    {
        id: 1,
        picture_link: 'slide1.png',
        date_start: 20191212,
        date_end: 20200312,
        name: '«Абилимпикс»',
        text:
            'Международное некоммерческое движение, в рамках которого' +
            ' ежегодно проводятся чемпионаты профмастерства среди людей с' +
            ' инвалидностью.',
        link: '#',
    },
    {
        id: 2,
        picture_link: 'slide2.png',
        date_start: 20191212,
        date_end: 20200312,
        name: 'Союз «Молодые профессионалы» (Вордскиллз Россия)',
        text:
            'Оператор международного движения WorldSkills, миссия которого' +
            ' – повышение стандартов подготовки кадров.',
        link: '#',
    },
    {
        id: 3,
        picture_link: 'slide3.png',
        date_start: 20191212,
        date_end: 20200312,
        name: '«CASE-IN»',
        text:
            'Крупнейший в России и странах СНГ инженерный чемпионат для' +
            ' молодежи, которая стремится профессионально развиваться в' +
            ' топливно-энергетическом и минерально-сырьевом комплексах.',
        link: '#',
    },
    {
        id: 4,
        picture_link: 'slide4.png',
        date_start: 20191212,
        date_end: 20200312,
        name: 'Клуб «Эльбрус». Уроки лидерства',
        text:
            'Социально-образовательная программа для школьников и' +
            ' студентов, созданная победителями конкурса «Лидеры России».',
        link: '#',
    },
    {
        id: 5,
        picture_link: 'slide5.png',
        date_start: 20191212,
        date_end: 20200312,
        name: 'Студенчесткая олимпиада «Я — профессионал»',
        text:
            'Многопрофильная олимпиада для студентов и выпускников' +
            ' российских вузов, кторая дает возможность не просто доказать' +
            ' свой профессионализм, но и обратить на себя внимание' +
            ' работодателей.',
        link: '#',
    },
    {
        id: 6,
        picture_link: 'slide6.png',
        date_start: 20191212,
        date_end: 20200312,
        name: '«Твой ход»',
        text:
            'Акция дала возможность выпускникам школ определить' +
            ' профессиональные и личные цели, зарядиться мотивацией и найти' +
            ' единомышленников.',
        link: '#',
    },
];

const events_from_server = [
    {
        id: 1,
        picture_link: 'slide7.jpg',
        date_start: 20191212,
        date_end: 20200312,
        name: 'Событие «Твой ход»',
        text: 'Текст про событие "Твой ход"',
        link: '#',
    },
    {
        id: 2,
        picture_link: 'slide4.png',
        date_start: 20191212,
        date_end: 20200312,
        name: 'Событие «CASE-IN»',
        text: 'Текст про событие "CASE-IN"',
        link: '#',
    },
    {
        id: 777,
        picture_link: 'slide5.png',
        date_start: 20191212,
        date_end: 20200312,
        name: 'Студенчесткое событие «Я — профессионал»',
        text: 'Текст про событие "Я — профессионал"',
        link: '#',
    },
    {
        id: 4,
        picture_link: 'slide6.png',
        date_start: 20191212,
        date_end: 20200312,
        name: '«Российское студенческое событие»',
        text: 'Текст про событие "Российское студенческое событие"',
        link: '#',
    },
];

const interns_from_server = [
    {
        id: 2,
        picture_link: 'slide2.png',
        date_start: 20191212,
        date_end: 20200312,
        name: '«Стажировка 1.0»',
        text: 'Замечательная стажировка, раз, два, три, четыре, пять, шесть,' + ' семь, восемь, девять, десять.',
        link: '#',
    },
    {
        id: 3,
        picture_link: 'slide3.png',
        date_start: 20191212,
        date_end: 20200312,
        name: '«Стажировка 2.0»',
        text: 'Тоже неплохая стажировка. Еще одна стажировка. Текст про' + ' стажировку.',
        link: '#',
    },
];

export default {
    state: {
        contest: null,

        contests: [],
        events: [],
        interns: [],

        project_types: [],
        thematic_areas: [],
    },
    mutations: {
        writeContest: (state, contest) => (state.contest = contest),

        writeContests: (state, contests) => (state.contests = contests),
        writeEvents: (state, events) => (state.events = events),
        writeInterns: (state, interns) => (state.interns = interns),

        writeProjectTypes: (state, pt) => (state.project_types = pt),
        writeThematicAreas: (state, ta) => (state.thematic_areas = ta),
    },
    actions: {
        loadContestsConfig: async (ctx) => {
            const filters = await get('projects', 'get/filters');

            // TODO: Что делать, если сервер не ответил?
            if (!filters) return;

            ctx.commit('writeProjectTypes', filters.project_types);
            ctx.commit('writeThematicAreas', filters.thematic_direction);
        },

        loadContest: (ctx, id) => {
            const on_response = async () => {
                const contest = await Object.assign(contest_from_server, {});
                const preload = await opp_img(contest);

                ctx.commit('writeContest', preload);
            };

            setTimeout(on_response, 500);
        },

        loadContests: (ctx) => {
            const on_response = async () => {
                const contests = await contests_from_server.slice(0);
                const preload = await Promise.all(contests.map(opp_img));

                ctx.commit('writeContests', preload);
            };

            setTimeout(on_response, 500);
        },

        loadEvents: (ctx) => {
            const on_response = async () => {
                const events = await events_from_server.slice(0);
                const preload = await Promise.all(events.map(opp_img));

                ctx.commit('writeEvents', preload);
            };

            setTimeout(on_response, 500);
        },

        loadInterns: (ctx) => {
            const on_response = async () => {
                const interns = await interns_from_server.slice(0);
                const preload = await Promise.all(interns.map(opp_img));

                ctx.commit('writeInterns', preload);
            };

            setTimeout(on_response, 500);
        },
    },
    getters: {
        contest: (state) => state.contest,

        contests: (state) => state.contests,
        events: (state) => state.events,
        interns: (state) => state.interns,

        project_types: (state) => state.project_types,
        thematic_areas: (state) => state.thematic_areas,
    },
};
